import React from 'react';
import '../../App.css';
import './CustomerFiles.css';
import { Space, Table, Tag } from 'antd';
import 'antd/dist/antd.css';
import './Sidebar.css'

export default function PatientMedicalRecords() {


    const columns = [
        {
            title: '#',
            dataIndex: 'id',
            key: 'id'
        },
        {
            title: 'Name',
            dataIndex: 'patientname',
            key: 'name',
            render: (name) => <>

                <div className='client_medicalrecords_table_client_name'>{name}</div>

            </>
        },
        {
            title: 'Date',
            dataIndex: 'date',
            key: 'date',
            render: (img) => <>
                <div className='client_medicalrecords_table_date_time_div'>
                    <div className='client_medicalrecords_table_appt_date'>11 nov 2019</div>
                    <div className='client_medicalrecords_table_appt_time'>10.00 pm</div>
                </div>
            </>
        },
        {
            title: 'Discription',
            dataIndex: 'discription',
            key: 'discription',
            render: (_, { discription }) => (
                <>
                    <div>{discription}</div>
                </>

            )
        },
        {
            title: 'Attachment',
            dataIndex: 'attachment',
            key: 'attachment',
            render: (_, { attachment }) => (
                <>
                    <div className='client_dashboard_table_view_download_section'>
                        <div><button className=' btn client_dashboard_table_view_download_button'><i class='fa-solid fa-download'></i></button></div>
                    </div>
                </>
            ),
        },
        {
            title: 'Orderd By',
            dataIndex: 'orderdby',
            key: 'orderdby',
        },
        {

            title: 'Action',
            key: 'action',
            dataIndex: 'action',
            render: (_, { action }) => (
                <>
                    <div>
                        <button className='btn client_medicalrecords_tabel_view_trash_button'><i class="fa-solid fa-trash-can"></i></button>
                    </div>
                </>
            ),
        },
    ];
    const data = [
        {
            key: '1',
            id: '1',
            patientname: 'John Brown',
            date: 32,
            discription: 'Rapalac Neuronium',
            orderdby: 'Your Self',

        },
        {
            key: '2',
            id: '2',
            patientname: 'John Brown',
            date: 32,
            discription: 'Ombinazol Bonibamol',
            orderdby: 'Your Self',

        },
        {
            key: '3',
            id: '3',
            patientname: 'John Brown',
            date: 32,
            discription: 'Dantotate Dantodazole',
            orderdby: 'Your Self',

        },
    ];

    const columnss = [
        {
            title: '#',
            dataIndex: 'id',
            key: 'id'
        },
        {
            title: 'Appt Date',
            dataIndex: 'date',
            key: 'date',
            render: (img) => <>
                <div className='client_medicalrecords_priscription_table_date_time_div'>
                    <div className='client_medicalrecords_priscription_table_appt_date'>11 nov 2019</div>
                    <div className='client_medicalrecords_priscription_table_appt_time'>10.00 pm</div>
                </div>
            </>
        },
        {
            title: 'Name',
            dataIndex: 'patientname',
            key: 'name',
            render: (name) => <>

                <div>{name}</div>

            </>
        },
        {
            title: 'Patient Name',
            dataIndex: 'patientname',
            key: 'name',
            render: (img) => <>
                <div className='client_medicalrecords_prescription_table_image_name_division'>
                    <div className='client_medicalrecords_prescription_table_image_division'>
                        <img className='client_medicalrecords_prescription_table_image' src={Image} height="50px" width="50px" />
                    </div>
                    <div className='client_medicalrecords_prescription_table_name_id_division'>
                        <div className='client_medicalrecords_prescription_table_client_name'>hiii</div>
                        <div className='client_medicalrecords_prescription_table_client_id'>#pt0016</div>
                    </div>
                </div>
            </>

        },
        {

            title: 'Action',
            key: 'tags',
            dataIndex: 'tags',
            render: (_, { tags }) => (
                <>
                    <div className='client_medicalrecord_priscription_tabel_print_view'>
                        <div><button className='btn client_medicalrecord_priscription_tabel_print_btn'><i class="fa-solid fa-print me-1"></i>Print</button></div>
                        <div><button className='btn client_medicalrecord_priscription_tabel_view_btn'><i class="fa-regular fa-eye me-1"></i>View</button></div>
                    </div>
                </>
            ),
        },
    ];
    const dataa = [
        {
            key: '1',
            id: '1',
            patientname: 'John Brown',
            date: 32,
        },
        {
            key: '1',
            id: '2',
            patientname: 'John Red',
            date: 32,
        },
        {
            key: '1',
            id: '3',
            patientname: 'John Blue',
            date: 32,
        },
    ];



    return (
        <div>
            <div>
                {/* breadcrumbs-start */}
                <div className='client_medicalrecords_breadcrumb_main_division'>
                    <div className='client_medicalrecords_breadcrumb_division'>
                        <p className='client_medicalrecords_breadcrumb_title'>home</p>
                        <p className='client_medicalrecords_breadcrumb_title1'>/</p>
                        <p className='client_medicalrecords_breadcrumb_title2'>Medical Records</p>
                    </div>
                    <div>
                        <h1 className='client_medicalrecords_breadcrumb_title_main'>Medical Records</h1>
                    </div>
                </div>
                {/* breadcrumbs-end */}

                <div className="container-fuild">
                    <div className='slidebar_and_component'>
                        <div className='sidebar_main_division'>
                            <div className='sidebar_division'></div>
                        </div>

                        <div className='component_division'>
                            <div className='client_medicalrecords_main_diviison'>
                                <div className=' client_medicalrecords_table_header '>
                                    <div class=" client_medicalrecords_medicalrec_section_active">
                                        Medical Records
                                    </div>
                                    <div class=" client_medicalrecords_medicalrec_section">
                                        Prescription
                                    </div>
                                </div>
                                <div className='client_medicalrecords_add_records_section'>
                                    <button type="button" className=" client_medical_records_add_records_button btn">Add Medical Records</button>
                                </div>
                                <div className='client_medicalrecords_table'>


                                    <div className='client_medical_records_table_division'>
                                        <Table columns={columns} dataSource={data} />
                                    </div>


                                    <div className='doctor_dashboard_client_appointment_table_division'>
                                        <Table columns={columnss} dataSource={dataa} />
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
